module.exports = __webpack_public_path__ + "img/solution.92b4200f.png";